import { interWbNavigate } from '@interco/inter-webview-bridge'

export const notNull = (value: string | null) => value !== null && value !== 'null'
export const handleBackButton = () => interWbNavigate.requestGoBack()

export * from './tailwind-utils'
export * from './theme-utils'
export * from './semver-utils'
export * from './url-utils'
export * from './language-utils'
export * from './resolveTrackEnvironment'
